"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _Duration = _interopRequireDefault(require("web/shared/telemetry/components/Duration"));
var _HistogramData = require("web/shared/telemetry/charts/Histogram.data.js");
var _HistogramStyles = require("web/shared/telemetry/charts/Histogram.styles.js");
var _popoverStyles = require("web/shared/telemetry/charts/popover.styles.js");
var _perfViewsStyles = require("web/shared/telemetry/perfViews.styles.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The histogram's bars and the axis they sit against, plus the popover naming
* whichever bucket the cursor is over.
*
* Separate from the panel that frames it: the panel owns how finely the data
* is cut, this owns drawing whatever cut it is given.
*/
function HistogramPlot(_ref) {
  let durationsMs = _ref.durationsMs,
    bucketCount = _ref.bucketCount;
  const _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    hovered = _useState2[0],
    setHovered = _useState2[1];
  const _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    lastHovered = _useState4[0],
    setLastHovered = _useState4[1];
  const histogram = (0, _HistogramData.buildHistogram)(durationsMs, bucketCount);
  if (histogram == null) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.muted)), {}, {
      children: "Nothing completed in this window, so there is no distribution to draw."
    }));
  }
  const active = hovered != null ? histogram.buckets[hovered] : null; // The last bucket pointed at, retained after the cursor leaves so the
  // popover has something to fade out *from* rather than vanishing.
  const settled = hovered != null ? hovered : lastHovered;
  const shown = settled != null ? histogram.buckets[settled] : null;
  const activeLeft = settled == null ? 0 : (settled + 0.5) / histogram.buckets.length * 100;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_HistogramStyles.styles.chartHolder)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_popoverStyles.styles.popover, active != null ? _popoverStyles.styles.popoverShownOverBar : _popoverStyles.styles.popoverHiddenOverBar)), {}, {
      style: {
        left: "".concat(activeLeft, "%"),
        bottom: "".concat(shown != null && histogram.peakCount > 0 ? shown.count / histogram.peakCount * 100 : 0, "%")
      },
      children: shown != null ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_popoverStyles.styles.popoverRow)), {}, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Duration.default, {
            ms: shown.fromMs
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_popoverStyles.styles.popoverSeparator)), {}, {
            children: "to"
          })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Duration.default, {
            ms: shown.toMs
          })]
        })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_popoverStyles.styles.popoverRow)), {}, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_popoverStyles.styles.popoverFigure)), {}, {
            children: shown.count
          })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_popoverStyles.styles.popoverWord)), {}, {
            children: shown.count === 1 ? "measurement" : "measurements"
          }))]
        }))]
      }) : null
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_HistogramStyles.styles.histogram)), {}, {
      onMouseLeave: () => setHovered(null),
      children: histogram.buckets.map((bucket, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_HistogramStyles.styles.histogramColumn)), {}, {
        onMouseEnter: () => {
          setHovered(index);
          setLastHovered(index);
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_HistogramStyles.styles.histogramBar, index === hovered && _HistogramStyles.styles.histogramBarActive)), {}, {
          style: {
            // Zero-count buckets keep a hairline so the axis reads as a
            // continuous range with gaps in it, rather than as missing.
            height: histogram.peakCount > 0 ? "".concat(Math.max(bucket.count / histogram.peakCount * 100, bucket.count > 0 ? 3 : 1), "%") : "1%"
          }
        }))
      }), bucket.fromMs))
    })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_HistogramStyles.styles.axis)), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.mono, _perfViewsStyles.styles.muted)), {}, {
        children: "0"
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.mono, _perfViewsStyles.styles.muted)), {}, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Duration.default, {
          ms: histogram.buckets[histogram.buckets.length - 1].toMs
        })
      }))]
    }))]
  }));
}
var _default = exports.default = HistogramPlot;